export interface CountryInfo {
  name: string
  officialLanguages: string[]
}

export const countryCodeMapping: Record<string, CountryInfo> = {
  AD: { name: 'Andorra', officialLanguages: ['Catalan'] },
  AE: { name: 'United Arab Emirates', officialLanguages: ['Arabic'] },
  AF: { name: 'Afghanistan', officialLanguages: ['Pashto', 'Dari'] },
  AG: { name: 'Antigua and Barbuda', officialLanguages: ['English'] },
  AI: { name: 'Anguilla', officialLanguages: ['English'] },
  AL: { name: 'Albania', officialLanguages: ['Albanian'] },
  AM: { name: 'Armenia', officialLanguages: ['Armenian'] },
  AO: { name: 'Angola', officialLanguages: ['Portuguese'] },
  AR: { name: 'Argentina', officialLanguages: ['Spanish'] },
  AS: { name: 'American Samoa', officialLanguages: ['English', 'Samoan'] },
  AT: { name: 'Austria', officialLanguages: ['German'] },
  AU: { name: 'Australia', officialLanguages: ['English'] },
  AW: { name: 'Aruba', officialLanguages: ['Dutch', 'Papiamento'] },
  AX: { name: 'Åland Islands', officialLanguages: ['Swedish'] },
  AZ: { name: 'Azerbaijan', officialLanguages: ['Azerbaijani'] },
  BA: { name: 'Bosnia and Herzegovina', officialLanguages: ['Bosnian', 'Croatian', 'Serbian'] },
  BB: { name: 'Barbados', officialLanguages: ['English'] },
  BD: { name: 'Bangladesh', officialLanguages: ['Bengali'] },
  BE: { name: 'Belgium', officialLanguages: ['Dutch', 'French', 'German'] },
  BF: { name: 'Burkina Faso', officialLanguages: ['French'] },
  BG: { name: 'Bulgaria', officialLanguages: ['Bulgarian'] },
  BH: { name: 'Bahrain', officialLanguages: ['Arabic'] },
  BI: { name: 'Burundi', officialLanguages: ['Kirundi', 'French'] },
  BJ: { name: 'Benin', officialLanguages: ['French'] },
  BL: { name: 'Saint Barthélemy', officialLanguages: ['French'] },
  BM: { name: 'Bermuda', officialLanguages: ['English'] },
  BN: { name: 'Brunei', officialLanguages: ['Malay'] },
  BO: { name: 'Bolivia', officialLanguages: ['Spanish', 'Quechua', 'Aymara'] },
  BQ: { name: 'Caribbean Netherlands', officialLanguages: ['Dutch'] },
  BR: { name: 'Brazil', officialLanguages: ['Portuguese'] },
  BS: { name: 'Bahamas', officialLanguages: ['English'] },
  BT: { name: 'Bhutan', officialLanguages: ['Dzongkha'] },
  BV: { name: 'Bouvet Island', officialLanguages: ['Norwegian'] },
  BW: { name: 'Botswana', officialLanguages: ['English', 'Tswana'] },
  BY: { name: 'Belarus', officialLanguages: ['Belarusian', 'Russian'] },
  BZ: { name: 'Belize', officialLanguages: ['English'] },
  CA: { name: 'Canada', officialLanguages: ['English', 'French'] },
  CC: { name: 'Cocos (Keeling) Islands', officialLanguages: ['English'] },
  CD: { name: 'Democratic Republic of the Congo', officialLanguages: ['French'] },
  CF: { name: 'Central African Republic', officialLanguages: ['French', 'Sango'] },
  CG: { name: 'Republic of the Congo', officialLanguages: ['French'] },
  CH: { name: 'Switzerland', officialLanguages: ['German', 'French', 'Italian', 'Romansh'] },
  CI: { name: "Côte d'Ivoire", officialLanguages: ['French'] },
  CK: { name: 'Cook Islands', officialLanguages: ['English', 'Cook Islands Maori'] },
  CL: { name: 'Chile', officialLanguages: ['Spanish'] },
  CM: { name: 'Cameroon', officialLanguages: ['English', 'French'] },
  CN: { name: 'China', officialLanguages: ['Chinese'] },
  CO: { name: 'Colombia', officialLanguages: ['Spanish'] },
  CR: { name: 'Costa Rica', officialLanguages: ['Spanish'] },
  CU: { name: 'Cuba', officialLanguages: ['Spanish'] },
  CV: { name: 'Cape Verde', officialLanguages: ['Portuguese'] },
  CW: { name: 'Curaçao', officialLanguages: ['Dutch', 'Papiamento', 'English'] },
  CX: { name: 'Christmas Island', officialLanguages: ['English'] },
  CY: { name: 'Cyprus', officialLanguages: ['Greek', 'Turkish'] },
  CZ: { name: 'Czech Republic', officialLanguages: ['Czech'] },
  DE: { name: 'Germany', officialLanguages: ['German'] },
  DJ: { name: 'Djibouti', officialLanguages: ['Arabic', 'French'] },
  DK: { name: 'Denmark', officialLanguages: ['Danish'] },
  DM: { name: 'Dominica', officialLanguages: ['English'] },
  DO: { name: 'Dominican Republic', officialLanguages: ['Spanish'] },
  DZ: { name: 'Algeria', officialLanguages: ['Arabic'] },
  EC: { name: 'Ecuador', officialLanguages: ['Spanish'] },
  EE: { name: 'Estonia', officialLanguages: ['Estonian'] },
  EG: { name: 'Egypt', officialLanguages: ['Arabic'] },
  EH: { name: 'Western Sahara', officialLanguages: ['Arabic'] },
  ER: { name: 'Eritrea', officialLanguages: ['Tigrinya', 'Arabic', 'English'] },
  ES: { name: 'Spain', officialLanguages: ['Spanish'] },
  ET: { name: 'Ethiopia', officialLanguages: ['Amharic'] },
  FI: { name: 'Finland', officialLanguages: ['Finnish', 'Swedish'] },
  FJ: { name: 'Fiji', officialLanguages: ['English', 'Fijian', 'Hindi'] },
  FK: { name: 'Falkland Islands', officialLanguages: ['English'] },
  FM: { name: 'Micronesia', officialLanguages: ['English'] },
  FO: { name: 'Faroe Islands', officialLanguages: ['Faroese', 'Danish'] },
  FR: { name: 'France', officialLanguages: ['French'] },
  GA: { name: 'Gabon', officialLanguages: ['French'] },
  GB: { name: 'United Kingdom', officialLanguages: ['English'] },
  GD: { name: 'Grenada', officialLanguages: ['English'] },
  GE: { name: 'Georgia', officialLanguages: ['Georgian'] },
  GF: { name: 'French Guiana', officialLanguages: ['French'] },
  GG: { name: 'Guernsey', officialLanguages: ['English', 'French'] },
  GH: { name: 'Ghana', officialLanguages: ['English'] },
  GI: { name: 'Gibraltar', officialLanguages: ['English'] },
  GL: { name: 'Greenland', officialLanguages: ['Greenlandic', 'Danish'] },
  GM: { name: 'Gambia', officialLanguages: ['English'] },
  GN: { name: 'Guinea', officialLanguages: ['French'] },
  GP: { name: 'Guadeloupe', officialLanguages: ['French'] },
  GQ: { name: 'Equatorial Guinea', officialLanguages: ['Spanish', 'French', 'Portuguese'] },
  GR: { name: 'Greece', officialLanguages: ['Greek'] },
  GS: { name: 'South Georgia and the South Sandwich Islands', officialLanguages: ['English'] },
  GT: { name: 'Guatemala', officialLanguages: ['Spanish'] },
  GU: { name: 'Guam', officialLanguages: ['English', 'Chamorro'] },
  GW: { name: 'Guinea-Bissau', officialLanguages: ['Portuguese'] },
  GY: { name: 'Guyana', officialLanguages: ['English'] },
  HK: { name: 'Hong Kong', officialLanguages: ['Chinese', 'English'] },
  HM: { name: 'Heard Island and McDonald Islands', officialLanguages: ['English'] },
  HN: { name: 'Honduras', officialLanguages: ['Spanish'] },
  HR: { name: 'Croatia', officialLanguages: ['Croatian'] },
  HT: { name: 'Haiti', officialLanguages: ['French', 'Haitian Creole'] },
  HU: { name: 'Hungary', officialLanguages: ['Hungarian'] },
  ID: { name: 'Indonesia', officialLanguages: ['Indonesian'] },
  IE: { name: 'Ireland', officialLanguages: ['Irish', 'English'] },
  IL: { name: 'Israel', officialLanguages: ['Hebrew', 'Arabic'] },
  IM: { name: 'Isle of Man', officialLanguages: ['English', 'Manx'] },
  IN: { name: 'India', officialLanguages: ['Hindi', 'English'] },
  IO: { name: 'British Indian Ocean Territory', officialLanguages: ['English'] },
  IQ: { name: 'Iraq', officialLanguages: ['Arabic', 'Kurdish'] },
  IR: { name: 'Iran', officialLanguages: ['Persian'] },
  IS: { name: 'Iceland', officialLanguages: ['Icelandic'] },
  IT: { name: 'Italy', officialLanguages: ['Italian'] },
  JE: { name: 'Jersey', officialLanguages: ['English', 'French'] },
  JM: { name: 'Jamaica', officialLanguages: ['English'] },
  JO: { name: 'Jordan', officialLanguages: ['Arabic'] },
  JP: { name: 'Japan', officialLanguages: ['Japanese'] },
  KE: { name: 'Kenya', officialLanguages: ['English', 'Swahili'] },
  KG: { name: 'Kyrgyzstan', officialLanguages: ['Kyrgyz', 'Russian'] },
  KH: { name: 'Cambodia', officialLanguages: ['Khmer'] },
  KI: { name: 'Kiribati', officialLanguages: ['English', 'Gilbertese'] },
  KM: { name: 'Comoros', officialLanguages: ['Arabic', 'French'] },
  KN: { name: 'Saint Kitts and Nevis', officialLanguages: ['English'] },
  KP: { name: 'North Korea', officialLanguages: ['Korean'] },
  KR: { name: 'South Korea', officialLanguages: ['Korean'] },
  KW: { name: 'Kuwait', officialLanguages: ['Arabic'] },
  KY: { name: 'Cayman Islands', officialLanguages: ['English'] },
  KZ: { name: 'Kazakhstan', officialLanguages: ['Kazakh', 'Russian'] },
  LA: { name: 'Laos', officialLanguages: ['Lao'] },
  LB: { name: 'Lebanon', officialLanguages: ['Arabic', 'French'] },
  LC: { name: 'Saint Lucia', officialLanguages: ['English'] },
  LI: { name: 'Liechtenstein', officialLanguages: ['German'] },
  LK: { name: 'Sri Lanka', officialLanguages: ['Sinhala', 'Tamil'] },
  LR: { name: 'Liberia', officialLanguages: ['English'] },
  LS: { name: 'Lesotho', officialLanguages: ['Sesotho', 'English'] },
  LT: { name: 'Lithuania', officialLanguages: ['Lithuanian'] },
  LU: { name: 'Luxembourg', officialLanguages: ['Luxembourgish', 'French', 'German'] },
  LV: { name: 'Latvia', officialLanguages: ['Latvian'] },
  LY: { name: 'Libya', officialLanguages: ['Arabic'] },
  MA: { name: 'Morocco', officialLanguages: ['Arabic'] },
  MC: { name: 'Monaco', officialLanguages: ['French'] },
  MD: { name: 'Moldova', officialLanguages: ['Romanian'] },
  ME: { name: 'Montenegro', officialLanguages: ['Montenegrin'] },
  MF: { name: 'Saint Martin', officialLanguages: ['French'] },
  MG: { name: 'Madagascar', officialLanguages: ['Malagasy', 'French'] },
  MH: { name: 'Marshall Islands', officialLanguages: ['Marshallese', 'English'] },
  MK: { name: 'North Macedonia', officialLanguages: ['Macedonian'] },
  ML: { name: 'Mali', officialLanguages: ['French'] },
  MM: { name: 'Myanmar', officialLanguages: ['Burmese'] },
  MN: { name: 'Mongolia', officialLanguages: ['Mongolian'] },
  MO: { name: 'Macau', officialLanguages: ['Chinese', 'Portuguese'] },
  MP: { name: 'Northern Mariana Islands', officialLanguages: ['English', 'Chamorro'] },
  MQ: { name: 'Martinique', officialLanguages: ['French'] },
  MR: { name: 'Mauritania', officialLanguages: ['Arabic'] },
  MS: { name: 'Montserrat', officialLanguages: ['English'] },
  MT: { name: 'Malta', officialLanguages: ['Maltese', 'English'] },
  MU: { name: 'Mauritius', officialLanguages: ['English', 'French'] },
  MV: { name: 'Maldives', officialLanguages: ['Divehi'] },
  MW: { name: 'Malawi', officialLanguages: ['English', 'Chichewa'] },
  MX: { name: 'Mexico', officialLanguages: ['Spanish'] },
  MY: { name: 'Malaysia', officialLanguages: ['Malay'] },
  MZ: { name: 'Mozambique', officialLanguages: ['Portuguese'] },
  NA: { name: 'Namibia', officialLanguages: ['English'] },
  NC: { name: 'New Caledonia', officialLanguages: ['French'] },
  NE: { name: 'Niger', officialLanguages: ['French'] },
  NF: { name: 'Norfolk Island', officialLanguages: ['English'] },
  NG: { name: 'Nigeria', officialLanguages: ['English'] },
  NI: { name: 'Nicaragua', officialLanguages: ['Spanish'] },
  NL: { name: 'Netherlands', officialLanguages: ['Dutch'] },
  NO: { name: 'Norway', officialLanguages: ['Norwegian'] },
  NP: { name: 'Nepal', officialLanguages: ['Nepali'] },
  NR: { name: 'Nauru', officialLanguages: ['Nauruan', 'English'] },
  NU: { name: 'Niue', officialLanguages: ['English', 'Niuean'] },
  NZ: { name: 'New Zealand', officialLanguages: ['English', 'Māori', 'NZ Sign Language'] },
  OM: { name: 'Oman', officialLanguages: ['Arabic'] },
  PA: { name: 'Panama', officialLanguages: ['Spanish'] },
  PE: { name: 'Peru', officialLanguages: ['Spanish', 'Quechua', 'Aymara'] },
  PF: { name: 'French Polynesia', officialLanguages: ['French'] },
  PG: { name: 'Papua New Guinea', officialLanguages: ['English', 'Tok Pisin', 'Hiri Motu'] },
  PH: { name: 'Philippines', officialLanguages: ['Filipino', 'English'] },
  PK: { name: 'Pakistan', officialLanguages: ['Urdu', 'English'] },
  PL: { name: 'Poland', officialLanguages: ['Polish'] },
  PM: { name: 'Saint Pierre and Miquelon', officialLanguages: ['French'] },
  PN: { name: 'Pitcairn Islands', officialLanguages: ['English'] },
  PR: { name: 'Puerto Rico', officialLanguages: ['Spanish', 'English'] },
  PS: { name: 'Palestine', officialLanguages: ['Arabic'] },
  PT: { name: 'Portugal', officialLanguages: ['Portuguese'] },
  PW: { name: 'Palau', officialLanguages: ['English', 'Palauan'] },
  PY: { name: 'Paraguay', officialLanguages: ['Spanish', 'Guaraní'] },
  QA: { name: 'Qatar', officialLanguages: ['Arabic'] },
  RE: { name: 'Réunion', officialLanguages: ['French'] },
  RO: { name: 'Romania', officialLanguages: ['Romanian'] },
  RS: { name: 'Serbia', officialLanguages: ['Serbian'] },
  RU: { name: 'Russia', officialLanguages: ['Russian'] },
  RW: { name: 'Rwanda', officialLanguages: ['Kinyarwanda', 'English', 'French'] },
  SA: { name: 'Saudi Arabia', officialLanguages: ['Arabic'] },
  SB: { name: 'Solomon Islands', officialLanguages: ['English'] },
  SC: { name: 'Seychelles', officialLanguages: ['French', 'English', 'Seychellois Creole'] },
  SD: { name: 'Sudan', officialLanguages: ['Arabic', 'English'] },
  SE: { name: 'Sweden', officialLanguages: ['Swedish'] },
  SG: { name: 'Singapore', officialLanguages: ['English', 'Malay', 'Mandarin', 'Tamil'] },
  SH: { name: 'Saint Helena', officialLanguages: ['English'] },
  SI: { name: 'Slovenia', officialLanguages: ['Slovene'] },
  SJ: { name: 'Svalbard and Jan Mayen', officialLanguages: ['Norwegian'] },
  SK: { name: 'Slovakia', officialLanguages: ['Slovak'] },
  SL: { name: 'Sierra Leone', officialLanguages: ['English'] },
  SM: { name: 'San Marino', officialLanguages: ['Italian'] },
  SN: { name: 'Senegal', officialLanguages: ['French'] },
  SO: { name: 'Somalia', officialLanguages: ['Somali', 'Arabic'] },
  SR: { name: 'Suriname', officialLanguages: ['Dutch'] },
  SS: { name: 'South Sudan', officialLanguages: ['English'] },
  ST: { name: 'São Tomé and Príncipe', officialLanguages: ['Portuguese'] },
  SV: { name: 'El Salvador', officialLanguages: ['Spanish'] },
  SX: { name: 'Sint Maarten', officialLanguages: ['Dutch', 'English'] },
  SY: { name: 'Syria', officialLanguages: ['Arabic'] },
  SZ: { name: 'Eswatini', officialLanguages: ['Swazi', 'English'] },
  TC: { name: 'Turks and Caicos Islands', officialLanguages: ['English'] },
  TD: { name: 'Chad', officialLanguages: ['Arabic', 'French'] },
  TF: { name: 'French Southern Territories', officialLanguages: ['French'] },
  TG: { name: 'Togo', officialLanguages: ['French'] },
  TH: { name: 'Thailand', officialLanguages: ['Thai'] },
  TJ: { name: 'Tajikistan', officialLanguages: ['Tajik'] },
  TK: { name: 'Tokelau', officialLanguages: ['Tokelauan', 'English'] },
  TL: { name: 'Timor-Leste', officialLanguages: ['Portuguese', 'Tetum'] },
  TM: { name: 'Turkmenistan', officialLanguages: ['Turkmen'] },
  TN: { name: 'Tunisia', officialLanguages: ['Arabic'] },
  TO: { name: 'Tonga', officialLanguages: ['English', 'Tongan'] },
  TR: { name: 'Turkey', officialLanguages: ['Turkish'] },
  TT: { name: 'Trinidad and Tobago', officialLanguages: ['English'] },
  TV: { name: 'Tuvalu', officialLanguages: ['Tuvaluan', 'English'] },
  TW: { name: 'Taiwan', officialLanguages: ['Mandarin Chinese'] },
  TZ: { name: 'Tanzania', officialLanguages: ['Swahili', 'English'] },
  UA: { name: 'Ukraine', officialLanguages: ['Ukrainian'] },
  UG: { name: 'Uganda', officialLanguages: ['English', 'Swahili'] },
  UM: { name: 'United States Minor Outlying Islands', officialLanguages: ['English'] },
  US: { name: 'United States', officialLanguages: ['English'] },
  UY: { name: 'Uruguay', officialLanguages: ['Spanish'] },
  UZ: { name: 'Uzbekistan', officialLanguages: ['Uzbek'] },
  VA: { name: 'Vatican City', officialLanguages: ['Italian', 'Latin'] },
  VC: { name: 'Saint Vincent and the Grenadines', officialLanguages: ['English'] },
  VE: { name: 'Venezuela', officialLanguages: ['Spanish'] },
  VG: { name: 'British Virgin Islands', officialLanguages: ['English'] },
  VI: { name: 'U.S. Virgin Islands', officialLanguages: ['English'] },
  VN: { name: 'Vietnam', officialLanguages: ['Vietnamese'] },
  VU: { name: 'Vanuatu', officialLanguages: ['Bislama', 'English', 'French'] },
  WF: { name: 'Wallis and Futuna', officialLanguages: ['French'] },
  WS: { name: 'Samoa', officialLanguages: ['Samoan', 'English'] },
  YE: { name: 'Yemen', officialLanguages: ['Arabic'] },
  YT: { name: 'Mayotte', officialLanguages: ['French'] },
  ZA: {
    name: 'South Africa',
    officialLanguages: [
      'Afrikaans',
      'English',
      'Ndebele',
      'Northern Sotho',
      'Sotho',
      'Swazi',
      'Tswana',
      'Tsonga',
      'Venda',
      'Xhosa',
      'Zulu',
    ],
  },
  ZM: { name: 'Zambia', officialLanguages: ['English'] },
  ZW: { name: 'Zimbabwe', officialLanguages: ['English', 'Shona', 'Ndebele'] },
}
